import React from "react";
import "./style.css";

const Loader = () => {
  return (
    <div className="body">
      <div className="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
